import React, { useEffect, useState, useRef } from "react";
import { filledInputClasses, Grid } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import MaterialTable from "@material-table/core";
import MainCard from '../../ui-component/cards/MainCard';
import SecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../store/constant';
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";
import { Label } from "reactstrap";
import pulse from "../../assets/images/icons/pulse.png";
import pulsered from "../../assets/images/icons/pulse_red.png";
import bill from "../../assets/images/icons/bill.png";
import bin from "../../assets/images/icons/bin.png";
import report from "../../assets/images/icons/report.png";
import tt from "../../assets/images/icons/tt_red.png";
import damage from "../../assets/images/icons/damage.png";
import moment from 'moment';
import axiosInstance from '../../axiosInstance';


const columns = [
    { title: "Activity Id", field: "activity_id" },
    { title: "Activity Name", field: "activity_name" },
    { title: "Activity Code", field: "activity_code" },
    { title: "Department Id", field: "dept_id" },
    { title: "Recieved Value", field: "recieved_value" },
    { title: "Issued Value", field: "issued_value" },
    { title: "BV", field: "bv" },
    { title: "Material Cost", field: "material_cost" },
    { title: "Direct Cost Salary", field: "direct_cost_salary" },
    { title: "Direct Cost OHS", field: "direct_cost_ohs" },
    { title: "Allocated Cost Salary", field: "allocated_cost_salary" },
    { title: "Allocated Cost OHS", field: "allocated_cost_ohs" },
];

function PassiveTyres() {
    // const [fleet_name, setFleetName] = useState('');
    // const [demoName, setDemoName] = useState('All Fleets');
    // const [startingDate, setStartingDate] = useState('20-02-01 00:00:00');
    // const [endDate, setEndDate] = useState('20-11-27 00:00:00');
    const [loading, setLoading] = useState(false);
    const [apiData, setAPIData] = useState([]);
    // const [tyre, setTyre] = useState('Passive_Tyre_report');
    // const [size, setSize] = useState('');
    // const [category, setCategory] = useState('');
    // const [pattern, setPattern] = useState('');

    // const [count, setCount] = useState(0);

    // Api Fetched Data
    const getData = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(`https://api.projectivetech.com/activity/`);
            console.log(res);
            // const actualData = await res.json();
            setAPIData(res.data);
            // setCount(actualData.data.length);
        } catch (error) {
            setAPIData([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getData();
    }, []);


    // const tableActions = [
    //     {
    //         icon: () =>

    //             <span style={{ display: 'flex', alignItems: 'center', paddingLeft: '12px' }}>
    //                 <p style={{
    //                     fontSize: '15px', paddingTop: '3px', color: 'gray',
    //                     fontWeight: '600'
    //                 }}>
    //                     Data Count : <span style={{ color: 'black' }}>{count}</span>
    //                 </p>
    //             </span >,


    //         tooltip: 'Data Count',
    //         isFreeAction: true
    //     }
    // ];


    ////////////////////// Fetch Start Time Data


    // const [startTimeData, setStartTimeData] = useState("");
    // const [endTimeData, setEndTimeData] = useState("");
    // const optionStartDate = {
    //     maxDate: new Date(),
    //     onChange: (selectedDates, dateStr, instance) => setStartTimeData(dateStr)
    // }

    // let sDataStart = startTimeData;
    // let slicedDataStart = sDataStart.slice(2, 4);
    // let anotherslicedDataStart = sDataStart.slice(4, sDataStart.length);
    // let StartingAddedData = slicedDataStart + anotherslicedDataStart + ' ' + '00:00:00';

    // const optionEndDate = {
    //     onChange: (selectedDates, dateStr, instance) => setEndTimeData(dateStr)
    // }
    // let sDataEnd = endTimeData;
    // let slicedDataEnd = sDataEnd.slice(2, 4);
    // let anotherslicedDataEnd = sDataEnd.slice(4, sDataEnd.length);
    // let endAddedData = slicedDataEnd + anotherslicedDataEnd + ' ' + '00:00:00';




    /////////////////////////////////////////////////////// Get All Fleet Data 

    // const [allFleetName, setAllFleetName] = useState([]);
    // const getAllFleetName = async () => {
    //     try {
    //         const res = await fetch(`https://bridgestone-api.nirmitee.tech/api/get_all_fleets/`);
    //         const actualData = await res.json();
    //         setAllFleetName(actualData);
    //     } catch (error) {
    //         setAPIData([]);

    //     }
    // }
    // useEffect(() => {
    //     getAllFleetName()
    // }, [])


    //Button Fetching 

    // const fetchedFilterData = async () => {
    //     setLoading(true);
    //     try {
    //         if (startTimeData == '') {
    //             const res = await fetch(`https://bridgestone-api.nirmitee.tech/report/Passive_Tyre_report/?Tyre_Status=Passive&Pattern=${pattern}&Size=${size}&Fleet_Name=${fleet_name}&limit=1000&offset=0`);
    //             const actualData = await res.json();
    //             setAPIData(actualData.data);
    //             setCount(actualData.data.length);
    //         } else {
    //             const res = await fetch(`https://bridgestone-api.nirmitee.tech/report/Passive_Tyre_report/?as_on_date=${StartingAddedData}&Fleet_Name=${fleet_name}&&Pattern=${pattern}&Size=${size}&Tyre_Status=Passive&limit=50&offset=0`);
    //             const actualData = await res.json();
    //             setAPIData(actualData.data);
    //             setCount(actualData.data.length);
    //         }
    //     } catch (error) {
    //         setAPIData([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    // useEffect(() => {
    //     fetchedFilterData()
    // }, []);



    ///////////////////////////////////////////////////////////////////////////////////Dynamic input Functionalities

    // const [dataForDynamicInputs, setDataForDynamicInputs] = useState([]);
    // const getDynamicInputsData = async () => {
    //     const res = await fetch(`https://bridgestone-api.nirmitee.tech/report/Passive_Tyre_report/?Tyre_Status=Passive&limit=50&offset=0`);
    //     const actualData = await res.json();
    //     setDataForDynamicInputs(actualData.data);
    // }
    // useEffect(() => {
    //     getDynamicInputsData();
    // }, []);

    //Pattern
    // const [patternData, setPatternData] = useState([]);
    // const FilteredDataforPatternInputs = dataForDynamicInputs.filter((item) => {
    //     return item.fleet_name == fleet_name
    // });
    // useEffect(() => {
    //     setPatternData(FilteredDataforPatternInputs);
    // }, [fleet_name]);
    // const uniquePattern = patternData.filter((obj, index) => {
    //     return index === patternData.findIndex(o => obj.tyre_pattern === o.tyre_pattern);
    // });

    // //Size
    // const [SizeData, setSizeData] = useState([]);
    // const FilteredDataforSizeInputs = dataForDynamicInputs.filter((item) => {
    //     return item.fleet_name == fleet_name
    // });
    // useEffect(() => {
    //     setSizeData(FilteredDataforSizeInputs);
    // }, [fleet_name]);

    // const uniqueSize = SizeData.filter((obj, index) => {
    //     return index === SizeData.findIndex(o => obj.tyre_size === o.tyre_size);
    // });

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // const inputRef = useRef();
    // const refComp1 = useRef(null);
    // const resetFilterData = async () => {
    //     setLoading(true);
    //     try {
    //         const res = await fetch(`https://bridgestone-api.nirmitee.tech/report/Passive_Tyre_report/?Tyre_Status=Passive&limit=1000&offset=0`);
    //         const actualData = await res.json();
    //         setPatternData([]);
    //         setSizeData([]);
    //         setFleetName('');
    //         setPattern('');
    //         setSize('');
    //         inputRef.current.value = "";
    //         setAPIData(actualData.data);
    //         setCount(actualData.data.length);
    //         refComp1.current.flatpickr.clear();
    //         console.log('successfully');
    //     } catch (error) {
    //         setAPIData([]);
    //         console.log(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const TableData = apiData;
    useEffect(() => {
        getData();
    }, []);


    // const formatter = Intl.NumberFormat('en-IN');
    // const changedTyreFormattedData = apiData.map(obj => {
    //     if (typeof obj.tyre_cost === 'number') {
    //         obj.tyre_cost = formatter.format(obj.tyre_cost);
    //     }
    //     return obj;
    // });


    // const changedTyreFormatedData = apiData.map((obj, index) => {
    //     let dTime = obj.delivery_date;
    //     if (dTime !== null) { // check if date is not null
    //         const croppedDate = dTime.slice(0, 10);
    //         if (moment(croppedDate, 'YYYY-MM-DD', true).isValid()) { // check if date is valid
    //             let dTime2 = moment(croppedDate).format('DD-MM-YYYY');
    //             obj.delivery_date = dTime2;
    //         } else {
    //             // set to original value if invalid
    //             obj.delivery_date = dTime;
    //         }
    //     } else {
    //         obj.delivery_date = null; // set to null if null
    //     }
    //     console.log(obj.delivery_date); // add console.log to check value
    //     return obj;
    // });


    console.log(apiData);

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            

            <MainCard style={{ color: ' ' }} title="Activity" secondary={<SecondaryAction />}>
                {/* <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid">
                        <Grid lg={4} sm={6} className="sad_Single">
                            <Label>Select Fleet</Label>
                            <select ref={inputRef} onChange={(e) => setFleetName(e.target.value)} className="form-select  fleetSlect">
                                <option className="options" value={''}>All Fleets</option>
                                {allFleetName.map((item, id) => {
                                    return (<>
                                        <option key={item.id} value={item.fields.fleet_name}>
                                            {item.fields.fleet_name}
                                        </option>
                                    </>)
                                })}
                            </select>
                        </Grid>


                        <Grid lg={4} md={3} sm={6} className="sad_Single2">
                            <Label>Select Pattern</Label>
                            <select onChange={(e) => setPattern(e.target.value)} className="form-select fleetSlect">
                                <option value={''}>All Pattern</option>
                                {uniquePattern.map((item, id) => {
                                    return (<>
                                        <option key={item.id} value={item.tyre_pattern}>
                                            {item.tyre_pattern}
                                        </option>
                                    </>)
                                })}
                            </select>
                        </Grid>



                        <Grid lg={4} md={3} sm={6} className="sad_Single2">
                            <Label>Select Size</Label>
                            <select onChange={(e) => setSize(e.target.value)} className="form-select fleetSlect">
                                <option value={''}>All Size</option>
                                {uniqueSize.map((item, id) => {
                                    return (<>
                                        <option key={item.id} value={item.tyre_size}>
                                            {item.tyre_size}
                                        </option>
                                    </>)
                                })}
                            </select>
                        </Grid>
                    </Grid>

                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid">
                        <Grid lg={4} sm={6} className="sad_Single">
                            <Label >As on delivery Date</Label>
                            <Flatpickr
                                ref={refComp1}
                                className="form-control fp_w-alp"
                                placeholder={'Select Delivery Date'}
                                options={optionStartDate}

                            />
                        </Grid>

                        <Grid lg={4} sm={6}>
                            <br></br>
                            <button className="fp_w_alp__vrb__button" style={{ marginLeft: '30px', marginTop: '10px' }} onClick={fetchedFilterData}>Fetch Data</button>
                        </Grid>

                        <Grid lg={4} sm={6}>
                            <br></br>
                            <button className="fp_w_alp__vrb__button" style={{ marginLeft: '30px', marginTop: '10px' }} onClick={resetFilterData}>Reset Filters</button>
                        </Grid>
                    </Grid>


                </Grid> */}

                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} sm={12} md={12} className="hiddenscrollDiv" style={{ maxWidth: '100%', width: '100%', overflowX: 'scroll' }}>
                        <MaterialTable
                            // actions={tableActions}
                            isLoading={loading}
                            title={"Data"}
                            columns={columns}
                            data={TableData}
                            options={{
                                pageSize: 10,
                                actionsColumnIndex: -1,
                                search: false,
                                grouping: false,
                                columnsButton: false,
                                paging: true,
                                showFirstLastPageButtons: false,
                                filtering: false,
                                columnsButton: false,
                                // exportMenu: [
                                //     {
                                //         label: "Export PDF",
                                //         exportFunc: (cols, datas) =>
                                //             ExportPdf(cols, datas, "myPdfFileName"),
                                //     },
                                //     {
                                //         label: "Export CSV",
                                //         exportFunc: (cols, datas) =>
                                //             ExportCsv(cols, datas, "myCsvFileName"),
                                //     },
                                // ],
                                headerStyle: {
                                    backgroundColor: "rgba(173, 216, 230, 0.281)",
                                    color: "black",
                                    width: "100vw",
                                    height: "80px",
                                    textAlign: "left",
                                    fontSize: "13px",
                                    fontWeight: "bolder",
                                    // borderLeft: '1px solid #bcbcbc',
                                    // borderRight: '1px solid #bcbcbc',
                                    // borderTop: '1px solid #bcbcbc'

                                },
                                cellStyle: {
                                    textAlign: "left",
                                    color: 'black',
                                    fontSize: '12px',
                                    fontWeight: "bolder",
                                    // borderLeft: '1px solid #bcbcbc',
                                    // borderRight: '1px solid #bcbcbc',

                                },

                            }}

                        />
                        <br></br> <br></br>
                    </Grid>
                </Grid>
            </MainCard>

            <Grid item xs={12} className="sub_div">
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={6} sm={6} xs={12}>
                        <Grid className="col-12 col-sm-12 text-center footer_inner_div">
                            &copy; {new Date().getFullYear()} IMAGE-I 
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default PassiveTyres









